var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_vm._v("欢迎使用捷思联想检验智能管控系统")])}
var staticRenderFns = []

export { render, staticRenderFns }